import React, { useState, useCallback } from "react";
import { Box, Button, Popover, StatusIndicator } from "@cloudscape-design/components";
import { JSONObject } from "../../services";
import { JsonFormatter } from "../../utils";
import { LABELS } from "../../constants";
import styles from "../../styles/v2.module.css";

interface JsonViewerProps {
  data: JSONObject | null;
  emptyMessage?: string;
  maxHeight?: number;
  darkMode?: boolean;
}

export const JsonViewer: React.FC<JsonViewerProps> = ({
  data,
  emptyMessage = LABELS.NO_DATA_AVAILABLE,
  maxHeight = 500,
  darkMode = false,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    if (data) {
      navigator.clipboard.writeText(JsonFormatter.stringify(data));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }, [data]);

  if (!data) {
    return (
      <Box textAlign="center" color="text-status-inactive" padding="l">
        <StatusIndicator type="stopped">{emptyMessage}</StatusIndicator>
      </Box>
    );
  }

  const formatted = JsonFormatter.stringify(data);
  const highlighted = JsonFormatter.syntaxHighlight(formatted, styles);
  const className = `${styles.jsonViewer} ${darkMode ? styles.jsonViewerDark : ""}`;

  return (
    <div className={styles.copyContainer}>
      <Box float="right" padding={{ top: "xs", right: "xs" }}>
        <Popover content={copied ? LABELS.COPIED : LABELS.COPY_JSON} dismissButton={false} position="top" size="small" triggerType="custom">
          <Button iconName="copy" variant="icon" onClick={handleCopy} ariaLabel={LABELS.COPY_JSON} />
        </Popover>
      </Box>
      <pre className={className} style={{ maxHeight }} dangerouslySetInnerHTML={{ __html: highlighted }} />
    </div>
  );
};
